import { __assign } from "tslib";
import { isHexColor } from 'wix-rich-content-common';
export var colorScheme = {
    dark1: {
        color: '#06070d',
        index: 0,
    },
    light1: {
        color: '#f2f2f2',
        index: 1,
    },
    green: {
        color: '#00e59b',
        index: 2,
    },
    red: {
        color: '#f53948',
        index: 3,
    },
    purple: {
        color: '#7579ff',
        index: 4,
    },
    blue: {
        color: '#0289ff',
        index: 5,
    },
};
export var viewerCustomForegroundStyleFn = function (style) {
    var colorRule = {};
    if (colorScheme[style] && isHexColor(colorScheme[style].color)) {
        colorRule = { color: colorScheme[style].color };
    }
    else if (isHexColor(style)) {
        colorRule = { color: style };
    }
    return colorRule;
};
export var customForegroundStyleFn = function (styles) {
    return styles.toArray().reduce(function (cssStyle, style) {
        return __assign(__assign({}, cssStyle), viewerCustomForegroundStyleFn(style));
    }, {});
};
export var viewerCustomBackgroundStyleFn = function (style) {
    var colorRule = {};
    if (colorScheme[style] && isHexColor(colorScheme[style].color)) {
        colorRule = { backgroundColor: colorScheme[style].color };
    }
    else if (isHexColor(style)) {
        colorRule = { backgroundColor: style };
    }
    return colorRule;
};
export var customBackgroundStyleFn = function (styles) {
    return styles.toArray().reduce(function (cssStyle, style) {
        return __assign(__assign({}, cssStyle), viewerCustomBackgroundStyleFn(style));
    }, {});
};
export var styleSelectionPredicate = function (style) {
    return ((colorScheme[style] && isHexColor(colorScheme[style].color)) ||
        isHexColor(style));
};
//# sourceMappingURL=text-color-style-fn.js.map